import { ArrowRightLeft, X, Loader2 } from 'lucide-react';

// Modale de réaffectation d'un code AVAILABLE (quiz → autre sujet, category → autre catégorie).
// reassignFor = { type: 'quiz'|'category', codeId, codeValue, currentTargetId, currentTargetLabel }
export default function ReassignCodeModal({ reassignFor, busy, error, onClose, onReassign, qcSousSujets, catList }) {
    return (
        <div className="sem-overlay" onClick={() => !busy && onClose()}>
            <div className="sem-modal" style={{ maxWidth: 520 }} onClick={e => e.stopPropagation()}>
                <div className="sem-header">
                    <ArrowRightLeft size={16} />
                    <span className="sem-title">Réaffecter le code {reassignFor.codeValue}</span>
                    <button className="sem-close" onClick={() => !busy && onClose()}><X size={18} /></button>
                </div>
                <div className="sem-section" style={{ padding: '14px 18px' }}>
                    <p style={{ fontSize: '0.86em', color: 'var(--text-muted)', marginTop: 0 }}>
                        Le code actuel cible <strong>{reassignFor.currentTargetLabel || '—'}</strong>. Choisissez une nouvelle cible (dans la même thématique) :
                    </p>
                    {error && (
                        <div className="sem-notice sem-notice--error" style={{ marginBottom: 10 }}>{error}</div>
                    )}
                    <div style={{ maxHeight: 360, overflowY: 'auto', border: '1px solid var(--border)', borderRadius: 6 }}>
                        {reassignFor.type === 'quiz' && qcSousSujets.map(ss => {
                            const ssId = ss.sous_sujet_id ?? ss.id;
                            const label = ss.sous_sujet_label || ss.label;
                            const isCurrent = Number(reassignFor.currentTargetId) === Number(ssId);
                            return (
                                <button key={ssId}
                                    onClick={() => !isCurrent && onReassign(ssId)}
                                    disabled={busy || isCurrent}
                                    style={{ display: 'block', width: '100%', textAlign: 'left', padding: '8px 12px', border: 'none', borderBottom: '1px solid var(--border)', background: isCurrent ? 'var(--bg-subtle, #f8fafc)' : 'transparent', cursor: isCurrent ? 'default' : 'pointer', fontSize: '0.88em', opacity: isCurrent ? 0.6 : 1 }}>
                                    {label}
                                    {isCurrent && <span style={{ marginLeft: 8, fontSize: '0.78em', color: 'var(--text-muted)' }}>(actuel)</span>}
                                </button>
                            );
                        })}
                        {reassignFor.type === 'category' && catList.map(cat => {
                            const isCurrent = Number(reassignFor.currentTargetId) === Number(cat.id);
                            return (
                                <button key={cat.id}
                                    onClick={() => !isCurrent && onReassign(cat.id)}
                                    disabled={busy || isCurrent}
                                    style={{ display: 'block', width: '100%', textAlign: 'left', padding: '8px 12px', border: 'none', borderBottom: '1px solid var(--border)', background: isCurrent ? 'var(--bg-subtle, #f8fafc)' : 'transparent', cursor: isCurrent ? 'default' : 'pointer', fontSize: '0.88em', opacity: isCurrent ? 0.6 : 1 }}>
                                    {cat.label}
                                    {isCurrent && <span style={{ marginLeft: 8, fontSize: '0.78em', color: 'var(--text-muted)' }}>(actuel)</span>}
                                </button>
                            );
                        })}
                        {reassignFor.type === 'quiz' && qcSousSujets.length === 0 && (
                            <div style={{ padding: 12, fontSize: '0.88em', color: 'var(--text-muted)', fontStyle: 'italic' }}>Aucun sujet disponible — créez-en un d'abord.</div>
                        )}
                        {reassignFor.type === 'category' && catList.length === 0 && (
                            <div style={{ padding: 12, fontSize: '0.88em', color: 'var(--text-muted)', fontStyle: 'italic' }}>Aucune catégorie — créez-en une d'abord.</div>
                        )}
                    </div>
                    {busy && (
                        <div style={{ marginTop: 10, fontSize: '0.86em', color: 'var(--text-muted)' }}>
                            <Loader2 size={13} className="spin" /> Réaffectation en cours…
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
